import Product from '../../Product/Product';

import { useSelector, useDispatch } from 'react-redux';
import * as actionCreators from '../../../store/actionCreators';
import * as Action from '../../../store/actions';
import Loader, { ShowEmptyView } from '../../UI/Loader/Loader.js';

function Main() {
  const state = useSelector((state) => state.product.frontend);
  const dispatch = useDispatch();
  const addToCart = (data) => {
    dispatch(actionCreators.addToCart(data));
    dispatch({
      type: Action.CREATE_ERROR,
      payload: { msg: `${data.title} added to cart`, type: 'success' },
    });
  };
  return (
    <div>
      {!state.productList && (
        <div className='h-[30rem] flex justify-center items-center'>
          <Loader />
        </div>
      )}
      {state.productList && state.productList.length === 0 && (
        <div className='h-[10rem] flex justify-center items-center'>
          <ShowEmptyView text='No products to show...' />
        </div>
      )}
      <div className='grid grid-cols-4'>
        {state.productList &&
          state.productList.map((el, id) => {
            return (
              <div key={id} className='m-[1rem]'>
                <Product
                  key={id}
                  productData={el}
                  addToCart={() =>
                    addToCart({
                      ...el,
                      noOfItems: 1,
                      total: parseInt(el.price),
                    })
                  }
                />
              </div>
            );
          })}
      </div>

      <div className='flex-col px-[2rem] py-[2rem] lg:py-[2rem] lg:px-[9.5rem] md:flex-row flex gap-16 lg:gap-24 justify-between'>
        <div className='flex-1'>
          <img
            src={'./images/sale.png'}
            alt='sale offer'
            className='block w-full object-contain'
          />
        </div>
        <div className='flex-1 text-greyPrimary'>
          <div className='w-full text-center mb-5 font-[700]  font-Poppins text-4xl'>
            <h1>We Have a Amazing Offers For you!!!</h1>
          </div>
          <p>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc
            vulputate libero et velit interdum, ac aliquet odio mattis. Class
            aptent taciti sociosqu ad litora torquent per conubia nostra, per
            inceptos himenaeos.
          </p>
        </div>
      </div>
    </div>
  );
}

export default Main;
